export default "__VITE_ASSET__CwZn0L3H__"